module.exports = "//public.getcloudapp.com/packs/media/images/icons-download-bordered-a1fa21535c5bbff76a6276876db4b88e.png";